<template>
	<div :style="{ display: topdisplayshowhide }" id="nonscrollheader">
		<div class="">
			<div class="row">
				<div class="col-sm-12 col-md-12 col-lg-3" style="z-index:9;">
					<router-link to="/">
						<div class=" h-100 d-flex justify-content-center align-items-center">
							<div class=" lg-images">
								<img :src="this.adminurl + 'logo.png'" alt="" class="logo-img-width">
							</div>
						</div>
					</router-link>
				</div>
				<div id="topmenuarea" class="col-md-9">
					<div id="HideManu" class="bg-top">
						<ul class="d-flex p-3">
							<li><a class="px-3" href=""><i
										class="fa fa-volume-control-phone icon-rotete  me-3"></i>Hotline:
									09614-50 51 51</a></li>
							<li><a class="px-3" href=""><i class="fa fa-phone me-3"></i>Phone: 02223371196-98</a></li>
							<li><a class="px-3" href=""><i class="fa fa-envelope-open-o me-3"></i>Email:
									hospital@pmcbd.com</a></li>
							<li><a class="px-3" href=""><i class="fa fa-clock-o me-3"></i>Open 24 Hours</a></li>
							<li><router-link to="/appointment" class="px-3" href=""><i class="far fa-plus-square plus-left fs-1"></i></router-link></li>
						</ul>

					</div>
					<div class="text-white main-header-nav">
						<nav class="navbar bootsnav navbar-expand-lg ">
							<div class="navbar-header">
							</div>
							<div class="collapse navbar-collapse" id="navbar-menu">
								<ul class="nav navbar-nav navbar-left" data-in="fadeIn">
									<li class="nav-item"><router-link to="/" class="nav-link ">Home</router-link>

									</li>
									<li class="nav-item "> <router-link to="/about" class="nav-link">About
											Us</router-link>

									</li>
									<li class="nav-item "> <router-link to="/appointment"
											class="nav-link">Appointment</router-link>

									</li>
									<li class="nav-item dropdown"> <a href="#" class="nav-link"
											data-toggle="dropdown">Service<i
												class="fa fa-angle-down color-blue ms-2 "></i></a>
										<ul class="dropdown-menu">
											<li><router-link to="/Card-service">Card Service</router-link></li>

											<li><router-link to="/Cabin-service">Cabin Service</router-link></li>
											<li><router-link to="/Diagnostics">Diagnostic Facilities</router-link></li>
										</ul>
									</li>
									<li class="nav-item dropdown"><a href="#" class="nav-link"
											data-toggle="dropdown">Management <i
												class="fa fa-angle-down color-blue ms-2 "></i></a>
										<ul class="dropdown-menu">
											<li><router-link to="/Chairperson">Chairperson</router-link></li>
											<li><router-link to="/managingDirector">Managing Director</router-link></li>
											<li><router-link to="/Adviser"
													href="page-team-three.html">Adviser</router-link>
											</li>
											<li><router-link to="/Director">Director</router-link></li>
										</ul>
									</li>

									<li class="nav-item dropdown"> <router-link to="/doctors" class="nav-link"
											data-toggle="dropdown">Our Doctors</router-link>
										<ul class="dropdown-menu">

										</ul>
									</li>
									<li class="nav-item dropdown megamenu-fw"> <a href="#" class="nav-link"
											data-toggle="dropdown"> Department <i
												class="fa fa-angle-down color-blue ms-2 "></i></a>
										<ul class="dropdown-menu megamenu-content" role="menu">
											<li>
												<div class="row">
													<div class="col-menu col-md-3">
														<h4 class="title">Clinical</h4>
														<div class="content">
															<ul class="menu-col">
																<li><router-link to="/MedicineAllied">Medicine &
																		Allied</router-link></li>
																<li><router-link to="/SurgeryAllied">Surgery &
																		Allied</router-link></li>
																<li><router-link to="/Obsgynae">Obs &
																		Gynae</router-link>
																</li>
																<li><router-link to="/Emergency"
																		href="blog-sidebar-less.html">Emergency</router-link>
																</li>
															</ul>
														</div>
													</div>
													<!-- end col-3 -->
													<div class="col-menu col-md-3">
														<h4 class="title">Special</h4>
														<div class="content">
															<ul class="menu-col">
																<li><router-link to="/ICU">ICU</router-link></li>
																<li><router-link to="/NICU">NICU</router-link></li>
																<li><router-link to="/CCU">CCU</router-link></li>
																<li><router-link to="/DiabeticClub">Diabetic
																		Club</router-link></li>
															</ul>
														</div>
													</div>
													<!-- end col-3 -->
													<div class="col-menu col-md-3">
														<h4 class="title">Allied</h4>
														<div class="content">
															<ul class="menu-col">
																<li><router-link to="/Dentistry">Dentistry</router-link>
																</li>
																<li><router-link to="/EPICorner">EPI
																		Corner</router-link>
																</li>
																<li><router-link to="/BloodBank">Blood
																		Bank</router-link>
																</li>
															</ul>
														</div>
													</div>
													<div class="col-menu col-md-3">
														<h4 class="title">Others</h4>
														<div class="content">
															<ul class="menu-col">
																<li><router-link to="/ItTeam">IT Team</router-link></li>
																<li><router-link to="/WashingPlant">Washing
																		Plant</router-link></li>
																<li><router-link to="/GaredgeService">Garedge
																		Service</router-link></li>

															</ul>
														</div>
													</div>
													<!-- end col-3 -->
												</div>
												<!-- end row -->
											</li>
										</ul>
									</li>
									<li class="nav-item dropdown"> <router-link to="/contactUs" class="nav-link"
											data-toggle="dropdown">Contact Us</router-link>

									</li>
								</ul>
							</div>
						</nav>
					</div>
				</div>
			</div>
		</div>
	</div>


	<!-- sticky manu state -->
	<div id="scrollmanu" :style="{ display: bottomdisplayshowhide }">
		<div class="scrollMenu">
			<div class="row">
				<div class="col-sm-12 col-md-12 col-lg-3" style="z-index:9;">
					<router-link to="/">
						<div class=" h-100 d-flex justify-content-center align-items-center">
							<div class=" lg-images">
								<img :src="this.adminurl + 'logo.png'" alt="" class="sticky-logo-img-width">
							</div>
						</div>
					</router-link>
				</div>
				<div class="col-md-9">
					<div class="text-white main-header-nav">
						<nav class="navbar bootsnav navbar-expand-lg ">
							<div class="collapse navbar-collapse" id="navbar-menu">
								<ul class="nav navbar-nav navbar-left" data-in="fadeIn">
									<li class="nav-item"><router-link to="/" class="nav-link ">Home</router-link>

									</li>
									<li class="nav-item "> <router-link to="/about" class="nav-link">About
											Us</router-link>

									</li>
									<li class="nav-item "> <router-link to="/appointment"
											class="nav-link">Appointment</router-link>

									</li>
									<li class="nav-item dropdown"> <a href="#" class="nav-link"
											data-toggle="dropdown">Service<i
												class="fa fa-angle-down color-blue ms-2 "></i></a>
										<ul class="dropdown-menu">
											<li><router-link to="/Card-service">Card Service</router-link></li>

											<li><router-link to="/Cabin-service">Cabin Service</router-link></li>
											<li><router-link to="/Diagnostics">Diagnostic Facilities</router-link></li>
										</ul>
									</li>
									<li class="nav-item dropdown"><a href="#" class="nav-link"
											data-toggle="dropdown">Management <i
												class="fa fa-angle-down color-blue ms-2 "></i></a>
										<ul class="dropdown-menu">
											<li><router-link to="/Chairperson">Chairperson</router-link></li>
											<li><router-link to="/managingDirector">Managing Director</router-link></li>
											<li><router-link to="/Adviser"
													href="page-team-three.html">Adviser</router-link>
											</li>
											<li><router-link to="/Director">Director</router-link></li>
										</ul>
									</li>

									<li class="nav-item dropdown"> <router-link to="/doctors" class="nav-link"
											data-toggle="dropdown">Our Doctors</router-link>
										<ul class="dropdown-menu">

										</ul>
									</li>
									<li class="nav-item dropdown megamenu-fw"> <a href="#" class="nav-link"
											data-toggle="dropdown"> Department <i
												class="fa fa-angle-down color-blue ms-2 "></i></a>
										<ul class="dropdown-menu megamenu-content" role="menu">
											<li>
												<div class="row">
													<div class="col-menu col-md-3">
														<h4 class="title">Clinical</h4>
														<div class="content">
															<ul class="menu-col">
																<li><router-link to="/MedicineAllied">Medicine &
																		Allied</router-link></li>
																<li><router-link to="/SurgeryAllied">Surgery &
																		Allied</router-link></li>
																<li><router-link to="/Obsgynae">Obs &
																		Gynae</router-link>
																</li>
																<li><router-link to="/Emergency"
																		href="blog-sidebar-less.html">Emergency</router-link>
																</li>
															</ul>
														</div>
													</div>
													<!-- end col-3 -->
													<div class="col-menu col-md-3">
														<h4 class="title">Special</h4>
														<div class="content">
															<ul class="menu-col">
																<li><router-link to="/ICU">ICU</router-link></li>
																<li><router-link to="/NICU">NICU</router-link></li>
																<li><router-link to="/CCU">CCU</router-link></li>
																<li><router-link to="/DiabeticClub">Diabetic
																		Club</router-link></li>
															</ul>
														</div>
													</div>
													<!-- end col-3 -->
													<div class="col-menu col-md-3">
														<h4 class="title">Allied</h4>
														<div class="content">
															<ul class="menu-col">
																<li><router-link to="/Dentistry">Dentistry</router-link>
																</li>
																<li><router-link to="/EPICorner">EPI
																		Corner</router-link>
																</li>
																<li><router-link to="/BloodBank">Blood
																		Bank</router-link>
																</li>
															</ul>
														</div>
													</div>
													<div class="col-menu col-md-3">
														<h4 class="title">Others</h4>
														<div class="content">
															<ul class="menu-col">
																<li><router-link to="/ItTeam">IT Team</router-link></li>
																<li><router-link to="/WashingPlant">Washing
																		Plant</router-link></li>
																<li><router-link to="/GaredgeService">Garedge
																		Service</router-link></li>

															</ul>
														</div>
													</div>
													<!-- end col-3 -->
												</div>
												<!-- end row -->
											</li>
										</ul>
									</li>
									<li class="nav-item dropdown"> <router-link to="/contactUs" class="nav-link"
											data-toggle="dropdown">Contact Us</router-link>

									</li>
								</ul>
							</div>
						</nav>
					</div>
				</div>
			</div>
		</div>
	</div>
	<!-- sticky manu end -->
	<!-- mobile manu -->
	<header id="mobilemanu" class="mobilemanu">
		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-6">
					<div class="mobile-logo">
						<img src="images/logo/primeHeaderLogo.png" alt="">
					</div>
				</div>
				<div class="col-sm-6">
					<div class="text-end">
						<i class="fa fa-bars menu-icon" @click="toggleSidebar"></i>
					</div>
				</div>
			</div>
		</div>
	</header>
	<aside :class="['sidebar', { open: isSidebarOpen }]">
		<!-- Close Icon -->
		 <router-link to="/">
			<div class="mobile-top my-5">
			<img class="" src="images/logo/primeHeaderLogo.png" alt="">
			<i class="fa fa-times close-icon" @click="toggleSidebar"></i>
		</div>
		 </router-link>
		<div class="bg-aside">
			<ul>
				<div class="w-100 d-flex justify-content-between px-4 py-3">
					<router-link to="/" @click="toggleSidebar" class="fw-bold text-white fs-40 fs-1 ">Home</router-link>
				</div>
			</ul>
		</div>
		<div class="bg-aside">
			<ul>
				<div class="w-100 d-flex justify-content-between px-4 py-3">
					<router-link to="/about" @click="toggleSidebar" class="fw-bold text-white fs-40 fs-1" href="#">About Us</router-link>
				</div>
			</ul>
		</div>
		<div class="bg-aside">
			<ul>
				<div class="w-100 d-flex justify-content-between px-4 py-3">
					<router-link to="/appointment" @click="toggleSidebar" class="fw-bold text-white fs-40 fs-1" href="#">Appoinment</router-link>
				</div>
			</ul>
		</div>
		<div class="bg-aside">
			<ul>
				<div @click="toggleDropdown('services')" class="w-100 d-flex justify-content-between px-4 py-3">
					<a class="fw-bold text-white fs-40 fs-1 " href="#">Services</a>
					<i class="fa fa-angle-down text-white fs-40 fs-1"></i>
				</div>
				<ul v-if="showDropdown == 'services'" class="dropdown-menu sub-class custom-drop">
					<li><router-link to="/card-service" @click="toggleSidebar">Card Service</router-link></li>
					<li><router-link to="/Cabin-service" @click="toggleSidebar">Cabin Service</router-link></li>
					<li><router-link to="/Diagnostics" @click="toggleSidebar">Diagnostic Facilities</router-link></li>
				</ul>
			</ul>
		</div>
		<div class="bg-aside">
			<ul>
				<div @click="toggleDropdown('management')" class="w-100 d-flex justify-content-between px-4 py-3">
					<a class="fw-bold text-white fs-40 fs-1">Management</a>
					<i class="fa fa-angle-down text-white fs-40 fs-1"></i>
				</div>
				<ul v-if="showDropdown == 'management'" class="dropdown-menu sub-class custom-drop">
					<li><router-link to="/Chairperson" @click="toggleSidebar">Chairperson</router-link></li>
					<li><router-link to="/managingDirector" @click="toggleSidebar">Managing Director</router-link></li>
					<li><router-link to="/Adviser" @click="toggleSidebar">Adviser</router-link></li>
					<li><router-link to="/Director" @click="toggleSidebar">Director</router-link></li>
				</ul>
			</ul>
		</div>

		<div class="bg-aside">
			<ul>
				<div class="w-100 d-flex justify-content-between px-4 py-3">
					<router-link to="/doctors" class="fw-bold text-white fs-40 fs-1" @click="toggleSidebar">Our Doctors</router-link>
				</div>
			</ul>
		</div>

		<div class="bg-aside">
			<ul>
				<div @click="toggleDropdown('departments')" class="w-100 d-flex justify-content-between px-4 py-3">
					<a class="text-white fw-bold fs-40  fs-1">Departments</a>
					<i class="fa fa-angle-down text-white fs-1"></i>
				</div>
				<ul v-if="showDropdown == 'departments'" class="dropdown-menu sub-class custom-drop">
					<li><router-link to="/MedicineAllied" @click="toggleSidebar">Medicine & Allied</router-link></li>
					<li><router-link to="/SurgeryAllied" @click="toggleSidebar">Surgery & Allied</router-link></li>
					<li><router-link to="/Obsgynae" @click="toggleSidebar">Obs & Gynae</router-link></li>
					<li><router-link to="/Emergency" @click="toggleSidebar">Emergency</router-link></li>
					<li><router-link to=/ICU @click="toggleSidebar">ICU</router-link></li>
					<li><router-link to="/NICU" @click="toggleSidebar">NICU</router-link></li>
					<li><router-link to="/CCU" @click="toggleSidebar">CCU</router-link></li>
					<li><router-link to="/DiabeticClub" @click="toggleSidebar">Diabetic Club</router-link></li>
					<li><router-link to="/Dentistry" @click="toggleSidebar">Dentistry</router-link></li>
					<li><router-link to="/EPICorner" @click="toggleSidebar">Epi Corner</router-link></li>
					<li><router-link to="/BloodBank" @click="toggleSidebar">blood Bank</router-link></li>
					<li><router-link to="/ItTeam" @click="toggleSidebar">IT Team</router-link></li>
					<li><router-link to="/WashingPlant" @click="toggleSidebar">Washing Plant</router-link></li>
					<li><router-link to="/GaredgeService" @click="toggleSidebar">Garedge Service</router-link></li>
				</ul>
			</ul>
		</div>
		<div class="bg-aside">
			<ul>
				<div class="w-100 d-flex justify-content-between px-4 py-3">
					<router-link to="/contactUs" class="fw-bold text-white fs-40 fs-1" @click="toggleSidebar">Contact Us</router-link>
				</div>
			</ul>
		</div>
	</aside>

</template>
<script>


import { ref } from "vue";
import axios from 'axios';
export default {
	computed: {
		adminurl() {
			return this.$store.state.adminurl;
		},
		url() {
			return this.$store.state.url;
		},
	},

	data() {
		return {

			showDropdown: null,
			hasScrolled: false,
			bottomdisplayshowhide: 'none',
			topdisplayshowhide: 'block'
		};
	},
	mounted() {
		// Add scroll event listener when the component is mounted
		window.addEventListener('scroll', this.handleScroll);
	},
	beforeDestroy() {
		// Remove event listener when the component is destroyed
		window.removeEventListener('scroll', this.handleScroll);
	},
	methods: {
		handleScroll() {
			if (window.scrollY >= 80) {
				this.hasScrolled = true;
				this.bottomdisplayshowhide = 'block';
				this.topdisplayshowhide = 'none';
				console.log('topclose');
			} else {
				this.hasScrolled = false;
				this.topdisplayshowhide = 'block';
				this.bottomdisplayshowhide = 'none';
				console.log('topopen');
			}
		},
		toggleDropdown(dropdown) {
			if (this.showDropdown == dropdown) {
				this.showDropdown = null;
			} else {
				this.showDropdown = dropdown;
			}
		}
	},
	setup() {
		// Reactive variable for sidebar state
		const isSidebarOpen = ref(false);

		// Function to toggle the sidebar
		const toggleSidebar = () => {
			isSidebarOpen.value = !isSidebarOpen.value;
		};

		return {
			isSidebarOpen,
			toggleSidebar,
		};
	},
};
</script>

<style scoped>
#nonscrollheader {
	position: relative;
	z-index: 10;
}

.sticky-logo-img-width[data-v-9e7c9af6] {
	width: 196px;
	padding: 10px 20px;
}

.scrollMenu {
	box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
	position: fixed;
	width: 100%;
	background-color: white;
	text-align: center;
	z-index: 9;
}
.dropdown-menu.sub-class {
	max-height: 400px;
	overflow-y: scroll;
}

.custom-drop {

	display: block;
	position: absolute;
	background-color: white;
	width: 100%;
	box-shadow: 10px 8px 16px;
}

.custom-drop li {
	padding: 8px 12px;
}

.custom-drop li a {
	color: green;
	font-weight: 700;
}

.custom-drop li:hover {
	background-color: #218847;
	color: white;
}

.custom-drop li a:hover {
	color: white;
}

.mobilemanu {
	top: 0 !important;
	width: 100%;
	position: fixed !important;
	background-color: #f7f7f7;
	color: #fff;
	display: flex;
	z-index: 9;
	align-items: center;
	padding: 10px 20px;
	position: relative;
}
.menu-icon{
		color: black;
		cursor: pointer;
		margin-top: 30px;
		border: 1px solid silver;
		padding: 25px;
		font-size: 54px;
		margin-right: 20px;
	}
	.mobile-top img {
     width: 400px ;
	}
.sidebar {
	z-index: 9;
	position: fixed;
	top: 0;
	left: -100%;
	width: 100%;
	height: 100%;
	background-color: #f7f7f7;
	/* color: #fff; */
	overflow-y: scroll;
	transition: 0.3s ease;
	padding: 10px;
}

.close-icon {
    /* top: 0; */
    margin-right: 43px;
    font-size: 50px;
    padding: 18px;
    margin-top: 40px;
    /* margin-top: 40px; */
    position: absolute;
    right: 0;
    border: 2px solid silver;
    opacity: 0.8;
}

.sidebar.open {
	left: 0;
}

.sidebar ul {
	list-style: none;
	padding: 0;
}

.sidebar ul li {
	padding: 10px 20px;
}

.sidebar ul li a {
	color: #008c42;
	font-family: 'Ubuntu';
	font-weight: 700;
	text-decoration: none;
	font-size: 31px;
}

#mobilemanu {
	display: none;
}

.bg-top {
	background-color: #008c42;
}

.bg-top ul li a {
	font-family: 'Ubuntu';
	font-size: 15px;
	font-weight: 400;
	color: #ffffff;
}

.plus-left {
	margin-left: 63px;
}

.icon-rotete {
	transform: rotate(326deg);
}

.h-100 {
	position: relative;
}

.lg-images:before {
	content: " ";
	position: absolute;
	top: -230px;
	right: -45px;
	bottom: 0;
	width: 100%;
	background-color: #fff;
	border-right: 2px solid #1db9a0;
	transform: skewX(-25deg);
	z-index: -1;
}

#topmenuarea {

	position: relative;
	/* left: -21px;
	position: relative; */
}

#topmenuarea::before {
	content: " ";
	position: absolute;
	width: 32px;
	height: 49px;
	background: #008c42;
	left: -14px;
}

.logo-img-width {
	padding: 8px;
	/* width: 125px; */
}

.color-blue {
	color: #008c42;
}

.menu-col li a:hover {
	padding-left: 15px !important;
	color: white !important;
	background: #008c42 !important;
}
</style>
